import { useRef, useState } from "react";

import styles from "./input.module.css";
import classNames from "classnames";
import { EyeIcon } from "../../assets/icons";

import { Text } from "../text/text";

export const Input = ({ type, value, setValue, error, label, autoComplete="off", ...props }) => {
    const ref = useRef(null);
    const [passwordVisible, setPasswordVisible] = useState(false);
    let placeholder=""
    if (type === "date")
        placeholder="дд/мм/гг"
    if (type === "time")
        placeholder="00:00"
    return (
        <div className={classNames(styles.input_container, {[styles.error]: error})}>
            {
                label &&
                <Text as="label" variant="caption" className={styles.label} >{label}</Text>
            }
            <div className={styles.input_wrapper} onClick={() => ref.current?.focus()}>
                <input
                    className={classNames(styles.input, {[styles.password]: type === "password"})}
                    ref={ref} 
                    type={type === "password" ? passwordVisible ? "text" : "password" : type}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    placeholder={placeholder}
                    autoComplete={autoComplete}
                    {...props}
                />
                {
                    type === "password" &&
                    <EyeIcon
                        style={{ cursor: "pointer" }}
                        className={classNames(styles.password_icon, {[styles.password_visible]: passwordVisible})}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={(e) => {
                            e.stopPropagation();
                            setPasswordVisible(prev => !prev);
                        }}
                    />
                }
            </div>
        </div>
    )
}
